/** Two letters for the account button: the first letters of the name's first
 * and last words, or the email's first letter. Only letters and digits count,
 * so "Seed owner (org)" reads SO and not S( (UX review 2026-11-01, UX-021).
 * Decorative — the button's name is the person's. */
export function initials(me: { user: { name?: string; email: string } } | undefined): string {
  const words = (me?.user.name || "").split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  const letters = words.length > 1 ? first(words[0]!) + first(words[words.length - 1]!)
    : words.length === 1 ? first(words[0]!)
    : first(me?.user.email ?? "");
  return letters.toUpperCase() || "?";
}

/** A word's first letter or digit, whole even outside the basic plane. */
function first(word: string): string {
  return word.match(/[\p{L}\p{N}]/u)?.[0] ?? "";
}
